import { Component, OnInit } from '@angular/core';
import { privilegesLinks } from './privileges.config';
import { ConfigService } from '../../../core/services/config.service';
import { PrivilegeConfig } from './models/privilege.model';

@Component({
  selector: 'app-my-privileges',
  templateUrl: './my-privileges.component.html',
  styleUrls: ['./my-privileges.component.scss']
})
export class MyPrivilegesComponent implements OnInit {
  privilegeLinks: PrivilegeConfig[] = privilegesLinks;

  constructor(private config: ConfigService) { }

  ngOnInit() {
    this.config.updateConfig(this.privilegeLinks);
    this.privilegeLinks = this.config.configData;
  }

  /**
   * 
   * @param menuItem Method to check role access for all links
   * @returns 
   */
  checkAccessForAllLinks(menuItem: PrivilegeConfig) {
    return menuItem.customerAssistanceTools.every(el => el.hasAccess);
  }
}
